module.exports = __webpack_public_path__ + "static/media/mastercard_rounded.85c5a82d.svg";